// ThemeProvider.js
import React, { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import { Global, css as css2 } from "@emotion/react";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import { antSwitch } from "./theme";
import {
  themeCreateAction,
  toggleThemeLoadingAction,
} from "../../../store/action/admin/themeActions";
import { generateCustomGlobalStyles } from "./CustomCss";
import MoreEmptyState from "../../../Theme/EmptyStates/MoreEmptyStates/MoreEmptyState";

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const [newConfig, setNewConfig] = useState(null);
  const [themeChangeValue, setThemeChangeValue] = useState(false);
  useEffect(() => {
    if (themeDefault?.info) {
      const generateNewConfig = () => {
        const newConfig = antSwitch(
          themeDefault?.info?.themeColor || "default",
          themeDefault?.info?.colorPrimary || "#f16444",
          themeDefault?.info?.language || "en",
          themeDefault?.info?.borderRadius || "8"
        );
        setNewConfig(newConfig);
      };
      setThemeChangeValue(true);
      generateNewConfig();
    }
  }, [
    // themeDefault?.info,
    themeDefault?.info?.themeColor,
    themeDefault?.info?.colorPrimary,
    themeDefault?.info?.colorSecondary,
    themeDefault?.loading,
  ]);
  useEffect(() => {
    if (themeDefault?.loading === false) {
      dispatch(
        themeCreateAction(
          {
            newConfig: { ...newConfig },
            status: "loaded",
          },
          true
        )
      );
    }
  }, [newConfig, dispatch]);

  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;
  const [token, setToken] = useState({});
  let themeValue = themeDefault?.info?.newConfig;
  const [themeColorSuccess, setThemeColorSuccess] = useState("#52C41A");
  const [themeColorError, setThemeColorError] = useState("#FF7875");

  useEffect(() => {
    if (themeValue?.theme === "purple" || themeValue?.theme === "dark") {
      setThemeColorError("#FFA39E");
      setThemeColorSuccess("#B7EB8F");
    } else {
      setThemeColorError("#FF7875");
      setThemeColorSuccess("#52C41A");
    }
    const token = {
      colorWarning: themeDefault?.info?.newConfig?.errorColor || "#FFC069",
      colorBgBase:
        themeValue?.theme === "default"
          ? "white"
          : themeDefault?.info?.newConfig?.backgroundAccentColor,
      colorPrimary: themeDefault?.info?.colorPrimary || "#f16444",
      borderRadius: `${themeDefault?.info?.borderRadius}px` || 8,
      colorPrimaryHover: themeDefault?.info?.colorPrimary || "#f16444",
      colorLink: themeValue?.anchorColor,
      // colorSuccess: themeColorSuccess,
      // colorError: themeColorError,
    };

    setToken(token);
  }, [themeDefault]);

  return (
    <ConfigProvider
      locale={themeDefault?.info?.language}
      direction={translations?.direction || "ltr"}
      theme={{
        fontFamilyCode: themeDefault?.info?.fontFamily,
        components: newConfig?.components,
        token: token,
        ...themeDefault?.info?.newConfig?.algorithm,
      }}
      form={{
        labelAlign: "left",
        requiredMark: true,
        requiredMarkRender: (label, required) => (
          <span>
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </span>
        ),
      }}
      renderEmpty={() => (
        <MoreEmptyState
          type="ErrorState"
          size="small"
          text="No data available"
        />
      )}
    >
      <Global styles={generateCustomGlobalStyles(themeDefault, newConfig)} />
      <div
        className={css`
          background-image: url(/apps${themeValue?.dashboardBackground}) !important;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          background-attachment: fixed;
          height: 100vh;
          overflow-y: auto;
        `}
      >
        {children}
      </div>
    </ConfigProvider>
  );
};
